module.exports = __webpack_public_path__ + "static/media/facebook-messenger.c1ff42c1.svg";